import { GETPROJECTTEMPLATE_SUCCESS, GETPROJECTTEMPLATE_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getProjectTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETPROJECTTEMPLATE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETPROJECTTEMPLATE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getProjectTemplateReducer;
